<!--Header Section-->
<div id="header" class="absolute top-0 left-0 w-[100%]">
    <div class="margin">
        <div class="nav-top bg-[#112c76] py-[1em] px-[20px]">
            <div class="container mx-auto">
                <div class="header-top-inner flex justify-between items-center flex-wrap">
                    <div class="header-top-links mb-4 md:mb-0">
                        <ul class="header-top-nav flex items-center m-0 p-0">
                            <li class="list-none">
                                <a target="_blank" href="mailto:sales@onetikk.com" class="text-[#fff] opacity-90 flex items-center text-[14px] font-normal hover:text-[#dbd1d1]">
                                    <span class="material-symbols-outlined mr-1">
                                    mail 
                                    </span>
                                 sales&#64;onetikk.com

                                </a>
                            </li>
                            <li class="ml-[24px] list-none">
                                <a href="#" class="text-[#fff] opacity-90 flex items-center text-[14px] font-normal hover:text-[#dbd1d1]">
                                    <span class="material-symbols-outlined mr-1">
                                        pin_drop
                                    </span>
                                    4th Floor,CDAC Building, Technopark Campus,<br/>Trivandrum, Kerala
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="header-top-contacts">
                        <ul class="header-top-nav flex items-center m-0 p-0">
                            <li class="list-none">
                                <a target="_blank" href="https://www.facebook.com/onetikk/" class="text-[#fff] opacity-90 w-auto h-auto text-[16px] font-normal hover:text-[#dbd1d1]">
                                    <i class="fa-brands fa-facebook-f"></i>
                                </a>
                            </li>
                            <li class="ml-[24px] list-none">
                                <a target="_blank" href="https://x.com/onetikk?lang=en" class="text-[#fff] opacity-90 w-auto h-auto text-[16px] font-normal hover:text-[#dbd1d1]">
                                    <i class="fa-brands fa-twitter"></i>
                                </a>
                            </li>
                            <li class="ml-[24px] list-none">
                                <a target="_blank" href="https://www.instagram.com/accounts/login/" class="text-[#fff] opacity-90 w-auto h-auto text-[16px] font-normal hover:text-[#dbd1d1]">
                                    <i class="fab fa-instagram"></i>
                                </a>
                            </li>
                            <li class="ml-[24px] list-none">
                                <a target="_blank" href="https://www.linkedin.com/company/onetikk/" class="text-[#fff] opacity-90w-auto h-auto text-[16px] font-normal hover:text-[#dbd1d1]">
                                    <i class="fa-brands fa-linkedin-in"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="nav-bottom">
            <nav class="relative flex flex-wrap items-center justify-between bg-[#112c763d] py-2 px-[20px]">
                <div class="container mx-auto flex flex-wrap items-center justify-between">
                    <div class="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
                        <a class="text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase text-white"
                            href="">
                            <img src="./assets/images/medease-logo-white.png" alt="" class="w-[180px]">
                        </a>
                        <div class="block lg:hidden">
                            <button mat-button
                                class="mob-nav-button cursor-pointer text-xl leading-none mt-2 px-3 py-1 border border-solid rounded bg-red-900  outline-none focus:outline-none"
                                type="button" (click)="toggleNavbar()">
                                <mat-icon class="text-white text-lg">menu</mat-icon>
                            </button>
                        </div>
                    </div>
                    <div class="lg:flex flex-grow items-center bg-white lg:bg-transparent sm:bg-white" [ngClass]="{'hidden': !showMenu, 'visible': showMenu}"
                        id="example-collapse-navbar">
                        <ul class="flex flex-col lg:flex-row lg:items-center list-none lg:ml-auto pb-[2em] lg:pb-0">
                            <li class="nav-item">
                                <a class="px-3 py-2 flex items-center text-small  leading-snug hover:opacity-75"
                                    href="/">
                                    <span class="ml-2 text-black lg:text-white">Home</span>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a href="/about" class="px-3 py-2 flex items-center text-small  leading-snug hover:opacity-75">
                                    <span class="ml-2 cursor-pointer text-black lg:text-white">About Us</span>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a href="/specialities" class="px-3 py-2 flex items-center text-small  leading-snug hover:opacity-75">
                                    <span class="ml-2 cursor-pointer text-black lg:text-white">Specialities</span>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a (click)="gotoDoctorsList()" class="px-3 py-2 flex items-center text-small  leading-snug hover:opacity-75">
                                    <span class="ml-2 cursor-pointer text-black lg:text-white">Doctors</span>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="px-3 py-2 flex items-center text-small  leading-snug hover:opacity-75"
                                    href="/faq">
                                    <span class="ml-2 text-black lg:text-white">FAQ</span>
                                </a>
                            </li> 
                            <li class="nav-item">
                                <a class="px-3 py-2 flex items-center text-small  leading-snug hover:opacity-75"
                                    href="/contact">
                                    <span class="ml-2 text-black lg:text-white">Contact Us</span>
                                </a>
                            </li> 
                          
                            <li class="nav-item mt-[1rem] lg:mt-0" *ngIf="isAuthenticated">
                                <a class="px-3 py-2 ml-[1em] lg:ml-[3em] text-sm font-medium leading-snug hover:opacity-75 lg:block custom-border bg-[#45a6d1]"
                                    href="/booking-list">
                                    <span class="ml-2">My Bookings(s)</span>
                                </a>
                            </li>
                            <li class="nav-item mt-[1rem] lg:mt-0" *ngIf="!isAuthenticated">
                                <a class="py-[20px] px-[14px] ml-[1em] lg:ml-[3em] text-small font-normal leading-snug hover:opacity-75 lg:block custom-border text-[#fff] bg-[#45a6d1] text-[14px] pointer rounded-[6px]"
                                    href="/login">
                                    <span class="ml-2">Login / Sign Up</span>
                                </a>
                            </li>
                            <li *ngIf="isAuthenticated" class="relative mt-[1em] lg:mt-0 ml-[1em] mr-2" (mouseenter)="showSubmenu()" (mouseleave)="hideSubmenu()">                           
                                <img src="/assets/images/profile.png" class="w-[25px] h-[25px] mt-1" >
                                <ul [ngClass]="{'block': isSubmenuOpen, 'hidden': !isSubmenuOpen}" class="absolute right-0 top-[20px] hidden p-3 divide-y divide-slate-200 bg-white border border-gray-200 shadow-lg mt-2 w-48 list-none">
                                    <li>
                                        <a href="/profile" class="flex p-1 items-center text-black hover:bg-slate-200 hover:rounded-lg text-sm font-medium"><span class="material-symbols-outlined mr-2">
                                            account_box
                                            </span> Profile</a>
                                    </li>
                                    <li class="mt-3 pt-3">
                                        <a (click)="logout()" class="flex p-1 items-center text-black hover:bg-slate-200 hover:rounded-lg text-sm font-medium"><span class="material-symbols-outlined mr-2">
                                            logout
                                            </span> Logout</a>
                                    </li>
                                </ul>                        
                            </li>
                          
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    </div>
    <div class=""></div>
</div>
<!--End Header Section-->